import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { logError } from 'lib/sentry/logError';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

import { UUID } from 'features/chat/config/types/Message';
import { useChatInterlocutorContext } from 'features/chat/context/chatInterlocutor';

export const useChatMessageScheduleSend = (
  options?: UseMutationOptions<any, any, any>
) => {
  const { chatId } = useChatInterlocutorContext();
  const { request } = useMutationHTTPRequest();
  const queryClient = useQueryClient();

  return useMutation(
    async (messageId: UUID) =>
      request({
        url: `/api/chats/${chatId}/scheduled-messages/${messageId}/send`,
      }),
    {
      ...options,
      onSettled: () => {
        queryClient.invalidateQueries([queryKeys.scheduledMessages, chatId]);
      },
      onError: (error) => {
        logError(error);
      },
    }
  );
};
